import React from "react";
import CurrencyFormat from "react-currency-format";

const TripExtraProductPage = ({ product, qty, onBack, onChangeQty, onAdd }) => {
  if (!product) return null;
  const unitZar =
    product.salePrice != null && product.salePrice > 0
      ? product.salePrice
      : product.price;
  const lineTotal = unitZar * (qty || 0);

  return (
    <div className="lp2-extras-pdp">
      <button type="button" className="lp2-extras-pdp-back" onClick={onBack}>
        <i className="mdi mdi-arrow-left" aria-hidden="true" /> Supplies
      </button>

      <div className="lp2-extras-pdp-image-wrap">
        {product.image ? (
          <img src={product.image} alt="" className="lp2-extras-pdp-image" />
        ) : (
          <div className="lp2-extras-pdp-image lp2-extras-pdp-image--placeholder">
            <i className="mdi mdi-package-variant" aria-hidden="true" />
          </div>
        )}
      </div>

      <h4 className="lp2-extras-pdp-title">{product.name}</h4>
      <div className="lp2-extras-pdp-price">
        {product.salePrice != null && product.salePrice < product.price ? (
          <>
            <span className="lp2-extras-pdp-price-sale">
              <CurrencyFormat
                value={product.salePrice}
                displayType="text"
                thousandSeparator
                prefix="R"
                decimalScale={2}
              />
            </span>
            <span className="lp2-extras-pdp-price-was">
              <CurrencyFormat
                value={product.price}
                displayType="text"
                thousandSeparator
                prefix="R"
                decimalScale={2}
              />
            </span>
          </>
        ) : (
          <CurrencyFormat
            value={unitZar}
            displayType="text"
            thousandSeparator
            prefix="R"
            decimalScale={2}
          />
        )}
      </div>

      {product.description ? (
        <p className="lp2-extras-pdp-desc">{product.description}</p>
      ) : null}

      <p className="lp2-extras-pdp-note">
        <i className="mdi mdi-truck-check-outline" aria-hidden="true" /> With your
        driver on collection day
      </p>

      <div className="lp2-extras-stepper lp2-extras-stepper--pdp">
        <span className="lp2-extras-stepper-label">Qty</span>
        <button
          type="button"
          className="lp2-extras-stepper-btn"
          aria-label={`Decrease quantity for ${product.name}`}
          onClick={() => onChangeQty(Math.max(0, (qty || 0) - 1))}
        >
          −
        </button>
        <span className="lp2-extras-stepper-qty">{qty || 0}</span>
        <button
          type="button"
          className="lp2-extras-stepper-btn"
          aria-label={`Increase quantity for ${product.name}`}
          disabled={
            (product.stock != null && product.stock <= (qty || 0)) ||
            (qty || 0) >= (product.meta?.maxQty || 10)
          }
          onClick={() => onChangeQty((qty || 0) + 1)}
        >
          +
        </button>
      </div>

      <button
        type="button"
        className="lp2-btn lp2-btn--primary lp2-btn--block lp2-extras-pdp-add"
        onClick={onAdd}
      >
        Add to move
        {qty > 0 ? (
          <>
            {" "}
            -{" "}
            <CurrencyFormat
              value={lineTotal}
              displayType="text"
              thousandSeparator
              prefix="R"
              decimalScale={2}
            />
          </>
        ) : null}
      </button>
    </div>
  );
};

export default TripExtraProductPage;
